import {
  wheelBustProvocation,
  wheelMultiplierProvocation,
  wheelProvocation,
} from "@karrtopelka/cards/provocations";
import type { CardProps } from "@karrtopelka/cards/types";
import type { OutcomeKind, SpinResult } from "@karrtopelka/game-kit";

/** Below this many total players, the "top X%" line is noise — omit it. */
const RANKLINE_MIN_TOTAL = 10;

/**
 * Build the result card from a spin. The display number + provocation depend on the
 * terminal outcome: a bust posts the LOST streak (the L is the joke); a multiplier
 * flexes the win; otherwise the normal streak line.
 */
export function buildWheelCard(
  streak: number,
  handle: string,
  spin: SpinResult | null,
  kind: OutcomeKind | null,
  /** For a bust, the streak that was lost (the pre-spin streak). Ignored otherwise. */
  lostStreak = 0,
): CardProps {
  if (kind === "bust") {
    return {
      game: "wheel",
      display: String(lostStreak),
      handle,
      provocation: wheelBustProvocation(lostStreak),
      date: today(),
    };
  }

  const provocation =
    kind === "x2" || kind === "jackpot"
      ? wheelMultiplierProvocation(streak)
      : wheelProvocation(streak);

  const props: CardProps = {
    game: "wheel",
    display: String(streak),
    handle,
    provocation,
    date: today(),
  };
  if (
    spin &&
    spin.total !== undefined &&
    spin.percentile !== undefined &&
    spin.total >= RANKLINE_MIN_TOTAL
  ) {
    return { ...props, rankLine: `top ${spin.percentile}% streak` };
  }
  return props;
}

function today(): string {
  return new Date().toISOString().slice(0, 10);
}
